<div class="bg-[#888888] md:flex">
        <div class="md:w-3/12"></div>
        <div class="md:w-9/12 md:pr-14 md:text-right">
                <button mat-button routerLink="/calculator"><mat-icon><img
                                        src="../../../assets/images/icons/calculator.svg" alt=""></mat-icon> Loan & Debt
                        Service Ratio Calculator</button>
                <button mat-button routerLink="/faq"><mat-icon><img src="../../../assets/images/icons/faq.svg"
                                        alt=""></mat-icon> Frequently Asked
                        Question</button>
                <button mat-button class="bg-primary" routerLink="/loan"><mat-icon><img
                                        src="../../../assets/images/icons/file.svg" alt=""></mat-icon> Loan
                        Application</button>
        </div>
</div>
<div class="bg-black text-white md:flex md:pl-16 md:pt-10 p-4">
        <div class="md:w-[14.2%] md:pr-2">
                <p class="text-[#888888] text-base font-medium uppercase">Models</p>
                <p class="mb-2"><a href="https://www.mitsubishi-motors.com.my/model/all-new-triton/"
                                [target]="target">All-New
                                Triton</a></p>
                <p class="mb-2"><a href="https://www.mitsubishi-motors.com.my/model/triton-single-cab/"
                                [target]="target">All-New Triton Single Cab</a></p>
                <p class="mb-2"><a href="https://www.mitsubishi-motors.com.my/model/new-xpander/" [target]="target">New
                                XPANDER</a></p>
                <p class="mb-2"><a href="https://www.mitsubishi-motors.com.my/model/triton-4x4/"
                                [target]="target">Triton
                                4x4</a></p>
                <!-- <p><a href="https://www.mitsubishi-motors.com.my/model/xpander/" [target]="target">XPANDER</a></p> -->
        </div>
        <div class="md:w-[14.2%] md:pr-2">
                <p class="text-[#888888] text-base font-medium uppercase">Shop Online</p>
                <p class="mb-2"><a href="https://www.mitsubishi-motors.com.my/book-online/" [target]="target">Book
                                Online</a>
                </p>
                <p class="mb-2"><a href="https://www.mitsubishi-motors.com.my/book-a-test-drive/" [target]="target">Book
                                a Test
                                Drive</a></p>
                <p class="mb-2"><a href="https://www.mitsubishi-motors.com.my/request-a-quote/"
                                [target]="target">Request a
                                Quote</a></p>
                <p class="mb-2"><a href="https://www.mitsubishi-motors.com.my/trade-in/" [target]="target">Trade-in Your
                                Vehicle</a>
                </p>

                <p><a [routerLink]="'/loan'">Track Loan Application</a>
                </p>
        </div>
        <div class="md:w-[14.2%] md:pr-2">
                <p class="text-[#888888] text-base font-medium uppercase">Buying Tools</p>
                <p class="mb-2"><a href="https://www.mitsubishi-motors.com.my/current-offers/" [target]="target">Current
                                Offers</a></p>
                <p class="mb-2"><a href="https://www.mitsubishi-motors.com.my/brochures/" [target]="target">Brochures &
                                Price
                                List</a></p>
                <p class="mb-2"><a href="https://www.mitsubishi-motors.com.my/certified-pre-owned/"
                                [target]="target">Certified
                                Pre-Owned</a></p>
                <p class="mb-2"><a href="https://www.mitsubishi-motors.com.my/locate-dealer/" [target]="target">Locate a
                                Dealer</a></p>
                <p><a href="https://www.mitsubishi-motors.com.my/loan-calculator/" [target]="target">Loan Calculator</a>
                </p>
        </div>
        <div class="md:w-[14.2%] md:pr-2">
                <p class="text-[#888888] text-base font-medium uppercase">Corporate</p>
                <p class="mb-2"><a href="https://www.mitsubishi-motors.com.my/corporate-sales/"
                                [target]="target">Overview</a>
                </p>
                <p class="mb-2"><a href="https://www.mitsubishi-motors.com.my/corporate-sales-aftersales/"
                                [target]="target">Aftersales</a></p>
                <p><a href="https://www.mitsubishi-motors.com.my/fleet-enquiries/" [target]="target">Fleet Enquiries</a>
                </p>
        </div>
        <div class="md:w-[14.2%] md:pr-2">
                <p class="text-[#888888] text-base font-medium uppercase">Owners</p>
                <p class="mb-2"><a href="https://www.mitsubishi-motors.com.my/maintenance-schedule/"
                                [target]="target">Maintenance Schedule</a></p>
                <p class="mb-2"><a href="https://www.mitsubishi-motors.com.my/vehicle-recall/" [target]="target">Vehicle
                                Recall</a></p>
                <p class="mb-2"><a href="https://www.mitsubishi-motors.com.my/update-owner-profile/"
                                [target]="target">Update
                                Owner Profile</a></p>
                <p class="mb-2"><a href="https://www.mitsubishi-motors.com.my/body-and-paint/" [target]="target">Body &
                                Paint
                                Services</a></p>
                <p class="mb-2"><a href="https://www.mitsubishi-motors.com.my/mitsubishi-connect-my/"
                                [target]="target">Mitsubishi Connect MY</a></p>
                <p class="mb-2"><a href="https://www.mitsubishi-motors.com.my/roadside-assistance-insurance/"
                                [target]="target">Roadside Assistance & Insurance</a></p>
                <p class="mb-2"><a href="https://www.mitsubishi-motors.com.my/owners-club/" [target]="target">Owners
                                Club</a>
                </p>
                <p><a href="https://mitsubishi-motors.com.my/xpanauts/homepage" [target]="target">Join XPANAUTS</a></p>
        </div>
        <div class="md:w-[14.2%] md:pr-2">
                <p class="text-[#888888] text-base font-medium uppercase">Discover</p>
                <p class="mb-2"><a href="https://www.mitsubishi-motors.com.my/about-us/" [target]="target">About Us</a>
                </p>
                <p class="mb-2"><a href="https://www.mitsubishi-motors.com.my/corporate-social-responsibilities/"
                                [target]="target">Corporate Social Responsibilities</a></p>
                <p class="mb-2"><a href="https://www.mitsubishi-motors.com.my/anti-bribery-and-anti-corruption-notice/"
                                [target]="target">Anti-Bribery & Anti Corruption Notice</a></p>
                <p class="mb-2"><a href="https://www.mitsubishi-motors.com.my/careers/" [target]="target">Careers</a>
                </p>
                <p><a href="https://www.mitsubishi-motors.com.my/contact-us/" [target]="target">Contact Us</a></p>
        </div>
        <div class="md:w-[14.2%]">
                <p class="text-[#888888] text-base font-medium uppercase">Connect</p>
                <p class="mb-2"><a href="https://www.mitsubishi-motors.com.my/news-events/" [target]="target">News &
                                Events</a>
                </p>
                <p class="mb-2"><a href="https://www.mitsubishi-motors.com.my/roadshow/" [target]="target">Roadshows</a>
                </p>
                <p><a href="https://www.mitsubishi-motors.com.my/articles/" [target]="target">Articles</a></p>
                <p class="flex">
                        <a href="https://www.facebook.com/MitsubishiMotorsMalaysia/" [target]="'_blank'">
                                <img src="../../../assets/images/icons/fb.svg" alt="" class="mr-5">
                        </a>
                        <a href="https://www.instagram.com/mitsubishimotorsmalaysia/" [target]="'_blank'">
                                <img src="../../../assets/images/icons/insta.svg" alt="" class="mr-5">
                        </a>
                        <a href="https://www.youtube.com/c/MitsubishiMotorsMalaysia" [target]="'_blank'">
                                <img src="../../../assets/images/icons/yt.svg" alt="">
                        </a>
                </p>
        </div>
</div>
<div class="bg-black text-white text-center py-3">
        <p class="mb-0">© 2024 Mitsubishi Motors Malaysia. All Rights Reserved.</p>
        <p><a href="https://www.mitsubishi-motors.com.my/copyright/" [target]="target">Copyright</a> | <a
                        href="https://www.mitsubishi-motors.com.my/copyright/" [target]="target">Privacy Policy</a></p>
</div>